import { FaCoins } from 'react-icons/fa'
import { ImHammer2 } from 'react-icons/im'
import { IoMdPeople } from 'react-icons/io'
import { TbBuildingEstate, TbMoneybag } from 'react-icons/tb'

export const bannerData = [
    {
        image: 'banner',
        heading: 'your trusted partner in comprehensive insurance solutions',
        text: 'We’re dedicated to protecting what matters most to you, from your health and assets to your business and future',
        bgColor: 'bg-[#0000006c]',
        textColor: 'text-[#fff]',
        link: '/about-us'
    },
    {
        image: 'banner2',
        heading: 'Discover a full range of insurance products ',
        text: 'Our mission is to empower individuals and businesses with secure, accessible, and personalized insurance coverage',
        bgColor: 'bg-[rgba(244,132,52,0.25)]',
        textColor: 'text-[#000]',
        link: '/about-us'

    },
    {
        image: 'banner3',
        heading: 'leader in insurance solutions for over 29 years',
        text: 'Our experienced team of professionals works to tailor policies that meet the unique needs of each client',
        bgColor: 'bg-[rgba(256,256,256,0.85)]',
        textColor: 'text-[#000]',
        link: '/contact'

    },
]

export const products = [
    {
        image: 'wealth',
        text: 'Wealth Management',
        icon: FaCoins,
        desc: 'Personalized solutions to grow and protect individual and family wealth.'
    },
    {
        image: 'asset',
        text: 'Asset Management',
        icon: TbMoneybag,
        desc: 'Comprehensive asset solutions for institutions and private clients.'
    },
    {
        image: 'estate',
        text: 'Real Estate Investment',
        icon: TbBuildingEstate,
        desc: 'Investment opportunities in prime real estate for diversified portfolios.'
    },
    {
        image: 'equity',
        text: 'Private Equity',
        icon: ImHammer2,
        desc: 'Access to high-potential, private-market investment opportunities.'
    },
    {
        image: 'advisory',
        text: 'Advisory Services',
        icon: IoMdPeople,
        desc: 'In-depth market insights and consulting for informed decision-making.'
    },
]

export const services = [
    {
        image: 'investment',
        heading: 'Investment & Trading',
        text: 'We engage in investments across different sectors, serving as commission agents, and managing wholesale and retail trade in textiles, electronics, furniture, cosmetics, and other consumer goods.',
    },
    {
        image: 'construction',
        heading: 'Contracting & Construction',
        text: 'Our contracting services include a broad range of construction activities, from building and demolition projects to land development and property  management. We have partnerships in place to deliver efficient and sustainable infrastructure projects.',
    },
    {
        image: 'manufacture',
        heading: 'Manufacturing & Retail',
        text: 'We provide manufacturing and retail solutions across various goods including textiles, household items, chemicals, and more. Our robust supply chain enables us to offer high-quality products to our clients, meeting both local and international demands.',
    },
    {
        image: 'oilgas',
        heading: 'Oil, Gas & Minerals',
        text: 'As an active participant in Nigeria\'s oil and gas sector, we specialize in exploration, production, and sales of petroleum products. We also engage in services such as oil well drilling, refinery operations, and petroleum marketing',
    },
    {
        image: 'transportation',
        heading: 'Logistics & Transportation',
        text: 'We offer transportation solutions within Nigeria and beyond, providing seamless movement of goods, mail, and passengers by land, sea, and air. Our logistics services ensure that clients\' needs are met efficiently and reliably.',
    },
]

export const navigationLinks = [
    // { path: '/', label: 'Home' },
    { path: '/about-us', label: 'About Us', isDropdown: true, dropdownItems: [{ path: '/about-us', label: 'About' }, { path: '/team', label: "Team" }] },
    { path: '/services', label: 'Services' },
    { path: '/media', label: 'Media' },
    { path: '/subsidiaries', label: 'Subsidiaries' },
    { path: '/contact', label: 'Contact' },
];

export const subsidiaries = [
    {
        image: 'carrierinsurance.jpg',
        heading: 'Trubond Insurance Brokers Limited',
        text: 'Trubond Insurance Brokers Limited is a premier insurance brokerage firm, offering a wide range of services including risk management, underwriting, and claims advisory. We provide tailored insurance solutions for individuals, businesses, and organizations, ensuring comprehensive coverage and peace of mind. With extensive market knowledge and a focus on client satisfaction, we help our clients navigate their insurance needs effectively.',
        link: 'www.carrierinsurancebrokers.com'
    },
    {
        image: 'truebondproperty.jpg',
        heading: 'TrueBond Properties and Leisure',
        text: "TrueBond Properties and Leisure is at the forefront of property management and development in Nigeria. We manage a portfolio of residential, commercial, and leisure properties, ensuring they are maintained to the highest standards of quality and service. Our focus is on maximizing the value of our properties while delivering outstanding experiences for tenants, homeowners, and investors alike.",
        link: 'www.truebondproperties.com.ng'
    },
    {
        image: 'privateequity.jpg',
        heading: 'TrueBond Private Equity',
        text: 'TrueBond Private Equity is a strategic investment firm focused on funding high-potential businesses across a range of sectors. We provide capital and expertise to help businesses grow, scale, and innovate, with a strong emphasis on long-term value creation. By partnering with businesses and entrepreneurs, we seek opportunities that generate both profitable returns and social impact, fostering sustainable business models that can thrive in today\'s dynamic market.',
    },
    {
        image: 'house.jpg',
        heading: 'Chris & Christene Limited',
        text: 'Chris & Christene Limited is focused on property ownership and investment. We own and manage a diverse portfolio of residential and commercial properties, strategically located to maximize value. With a focus on long-term growth and sustainability, Chris & Christene Limited is committed to providing high-quality, well-located properties that enhance the built environment and contribute to the development of thriving communities.',
        link: 'www.c-c-foundation.com'
    },
    {
        image: 'charity.jpg',
        heading: 'Chris and Christene Foundation',
        text: 'The Chris and Christene Foundation is the charitable arm of TrueBond Global Investments, dedicated to supporting education, health, and social well-being. Through strategic initiatives and partnerships with local communities and organizations, we aim to improve access to education, enhance healthcare services, and promote sustainable development. Our foundation is driven by a mission to create positive social impact and empower communities for a better future.',
    },
    {
        image: 'bookhouse.jpg',
        heading: 'Book House Limited',
        text: 'Book House Limited is a leading provider of educational resources, specializing in the publishing and distribution of books, educational materials, and learning tools. We are committed to supporting education at all levels by providing access to high-quality educational content. Through our services, we aim to promote literacy, foster a culture of lifelong learning, and contribute to the advancement of education in Nigeria and beyond.',
    },
]